import React from "react";

const InfiniteScrollView = ({
	children,
	renderIsLoading,
	isLoading = false,
	loadMore,
    loadMoreParams = {},
	viewId = "review-list-items-id",
	lastItemClass = "last-list-item-scroll",
}) => {

    const init = (callBackParams) => {
        const view = document.getElementById(viewId);
		if (view) {
			view.addEventListener("scroll", (e) => {
				const a = e?.target?.getBoundingClientRect()?.bottom;
				const b = e?.target
					?.getElementsByClassName(lastItemClass)
					?.item(0)
					?.getBoundingClientRect()?.bottom;
				if (a / b >= 0.98 && !isLoading) {
					loadMore && loadMore(callBackParams);
				}
			});
		}
    }

	React.useEffect(() => {
		if(loadMoreParams)init(loadMoreParams)
	}, [loadMoreParams]);

	return (
		<>
			{children} {isLoading && renderIsLoading && renderIsLoading()}{" "}
		</>
	);
};

export default InfiniteScrollView;
